import React, { useState } from 'react';
import { AuthProvider, useAuth } from './AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Events from './pages/Events';
import Contact from './pages/Contact';
import JoinUs from './pages/JoinUs';
import Schedule from './pages/Schedule';
import Collaboration from './pages/Collaboration';
import AuthModal from './components/AuthModal';
import Toast from './components/Toast';
import './App.css';

function AppContent() {
  const [currentPage, setCurrentPage] = useState('home');
  const [showAuth, setShowAuth] = useState(false);
  const [toast, setToast] = useState(null);
  const { user, signOut } = useAuth();

  const navigate = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  const openAuth = () => setShowAuth(true);

  const pages = {
    home: Home, about: About, events: Events,
    contact: Contact, join: JoinUs, schedule: Schedule,
    collaboration: Collaboration,
  };
  const PageComponent = pages[currentPage] || Home;

  return (
    <div className="app">
      <Navbar
        currentPage={currentPage}
        navigate={navigate}
        onAuthClick={openAuth}
        user={user}
        onSignOut={async () => { await signOut(); showToast('Signed out successfully'); }}
      />
      <main key={currentPage} className="page-fade">
        <PageComponent
          navigate={navigate}
          showToast={showToast}
          onAuthClick={openAuth}
        />
      </main>
      {showAuth && (
        <AuthModal onClose={() => setShowAuth(false)} showToast={showToast} />
      )}
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
